import request from './request'
import auth from './auth'

import actuaciones from './actuaciones'
import imagenSatelite from './imagenSatelite'
import imagenEmergencia from './imagenEmergencia'
import incendio from './incendio'
import medio from './medio'
import parametro from './parametro'
import planificacion from './planificacion'
import proxy from './proxy'
import simulacion from './simulacion'
import infraestructura from './infraestructura'
import equipo from './equipo'
import usuario from './usuario'
import personalMedioTipo from './personalMedioTipo'
import personal from './personal'
import medioDispositivo from './medioDispositivo'
import proveedor from './proveedor/proveedor'
import personalCategoria from './personalCategoria'
import imagenInfraestructura from './imagenInfraestructura'
import demarcacion from './demarcacion'
import personalTipo from './personalTipo'
import tituloProfesional from './tituloProfesional'
import organismo from './organismo'
import imagenPersonal from './imagenPersonal'
import emergencia from './emergencias'

import others from './others'

export default {
  request,

  auth,

  actuaciones,
  imagenEmergencia,
  imagenSatelite,
  incendio,
  medio,
  parametro,
  planificacion,
  proxy,
  proveedor,
  infraestructura,
  simulacion,
  equipo,
  usuario,
  personalMedioTipo,
  personal,
  personalCategoria,
  imagenInfraestructura,
  demarcacion,
  personalTipo,
  tituloProfesional,
  organismo,
  imagenPersonal,
  emergencia,

  others
}
